export const SERIAL_NUMBERS_LIST_FIELDS = [
  {
    name: 'Serial number',
  },
  {
    name: 'SN partner',
  },
  {
    name: 'Type',
  },
  {
    name: 'IMO',
  },
  {
    name: 'Vessel',
  },
  {
    name: 'Commissioning date',
  },
  {
    name: 'Validity',
  },
  {
    name: 'Actions',
  },
];

export const REGISTRATION_HISTORY_FIELDS = [
  {
    name: 'Serial number',
  },
  {
    name: 'SN partner',
  },
  {
    name: 'Type',
  },
  {
    name: 'IMO',
  },
  {
    name: 'Vessel',
  },
  {
    name: 'Commissioning date',
  },
  {
    name: 'Validity',
  },
  {
    name: 'Last external calibration',
  },
  {
    name: 'Actions',
  },
];
